export const EXCEPTION = {
  FBConnection: {
    code: 70,
    message: "연결중 오류가 발생 하였습니다. 다시 방송에 참여 해주세요",
  },
}
